export const changeTheme = theme => ({ type: "CHANGE_THEME", theme });
export const changeToolbarColor = toolbarColor => ({ type: "CHANGE_TOOLBAR_COLOR", toolbarColor });
export const changePrimaryColor = primaryColor => ({ type: "CHANGE_PRIMARY_COLOR", primaryColor });
export const changeSecondaryColor = secondaryColor => ({ type: "CHANGE_SECONDARY_COLOR", secondaryColor });
export const changeLanguage = language => ({ type: "CHANGE_LANGUAGE", language });
